import { useContext } from 'react';

import { DecedentFilterContext } from '../context';

const useDecedentFilters = () => {
  const context = useContext(DecedentFilterContext);

  if (!context) {
    throw new Error('useDecedentFilters must be used within a DecedentFilterProvider');
  }

  return context;
};

export default useDecedentFilters;
